// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.PhoneInput:disabled {
  opacity: 0.38;
}

/* .PhoneInput:not(:active):not(:focus):not(:hover) {
} */

.PhoneInput::placeholder {
  color: rgba(46, 46, 46, 0.38);
}

.PhoneInput:focus,
.PhoneInput:active {
  outline: 2px solid black;
}

.PhoneInput:hover:not(:active):not(:focus) {
  outline: 1px solid black;
}

.PhoneInputInput {
    font: inherit;
    letter-spacing: inherit;
    color: currentColor;
    padding: 4px 0 5px;
    border: 0;
    box-sizing: content-box;
    background: none;
    height: 1.4375em;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    display: block;
    min-width: 0;
    width: 100%;
    animation-name: mui-auto-fill-cancel;
    animation-duration: 10ms;
    padding: 16.5px 14px;
  }

.PhoneInputCountry {
  min-width: 64px;
  justify-content: center;
}

.PhoneInputCountry:focus,
.PhoneInputCountry:active {
  outline: 2px solid black;
}

.PhoneInput {
  display: flex;
  outline: 1px solid rgba(46, 46, 46, 0.38);
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":";AACA;EACE,aAAa;AACf;;AAEA;GACG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,wCAAwC;IACxC,cAAc;IACd,YAAY;IACZ,WAAW;IAEX,oCAAoC;IAEpC,wBAAwB;IACxB,oBAAoB;EACtB;;AAEF;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,YAAY;AACd","sourcesContent":["\n.PhoneInput:disabled {\n  opacity: 0.38;\n}\n\n/* .PhoneInput:not(:active):not(:focus):not(:hover) {\n} */\n\n.PhoneInput::placeholder {\n  color: rgba(46, 46, 46, 0.38);\n}\n\n.PhoneInput:focus,\n.PhoneInput:active {\n  outline: 2px solid black;\n}\n\n.PhoneInput:hover:not(:active):not(:focus) {\n  outline: 1px solid black;\n}\n\n.PhoneInputInput {\n    font: inherit;\n    letter-spacing: inherit;\n    color: currentColor;\n    padding: 4px 0 5px;\n    border: 0;\n    box-sizing: content-box;\n    background: none;\n    height: 1.4375em;\n    margin: 0;\n    -webkit-tap-highlight-color: transparent;\n    display: block;\n    min-width: 0;\n    width: 100%;\n    -webkit-animation-name: mui-auto-fill-cancel;\n    animation-name: mui-auto-fill-cancel;\n    -webkit-animation-duration: 10ms;\n    animation-duration: 10ms;\n    padding: 16.5px 14px;\n  }\n\n.PhoneInputCountry {\n  min-width: 64px;\n  justify-content: center;\n}\n\n.PhoneInputCountry:focus,\n.PhoneInputCountry:active {\n  outline: 2px solid black;\n}\n\n.PhoneInput {\n  display: flex;\n  outline: 1px solid rgba(46, 46, 46, 0.38);\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
